import { frontendURL } from "../../../helper/URLHelper";

export default {
  routes: [
    {
      path: frontendURL("accounts/:accountId/asistentes-ia"),
      meta: {
        permissions: ["administrator"],
      },
      children: [
        {
          path: "",
          redirect: "configuracion",
        },
        {
          path: "configuracion",
          name: "asistentes_ia_configuracion",
          component: () => import("./Index.vue"),
          meta: {
            permissions: ["administrator"],
          },
        },
        {
          path: "herramientas",
          name: "asistentes_ia_herramientas",
          component: () => import("./Herramientas.vue"),
          meta: {
            permissions: ["administrator"],
          },
        },
      ],
    },
  ],
};
